import React from 'react';
import { IconButton, MenuItem, Select, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { baseColors } from '../../Themes/colors';
var getRowOptions = function () { return [10, 25, 50, 100]; };
var CommonTablePagination = function (_a) {
    var _b;
    var tableData = _a.tableData, setCurrentPage = _a.setCurrentPage, setPerPageCount = _a.setPerPageCount, currentPage = _a.currentPage, perPageCount = _a.perPageCount, totalNumberOfRecords = _a.totalNumberOfRecords, hideRowsPerPage = _a.hideRowsPerPage;
    var totalRecords = (_b = totalNumberOfRecords !== null && totalNumberOfRecords !== void 0 ? totalNumberOfRecords : tableData === null || tableData === void 0 ? void 0 : tableData.length) !== null && _b !== void 0 ? _b : 0;
    var rowOptions = getRowOptions();
    var totalPages = Math.max(1, Math.ceil(totalRecords / perPageCount));
    var canGoPrev = currentPage > 1;
    var canGoNext = currentPage < totalPages;
    var initializedRef = React.useRef(false);
    React.useEffect(function () {
        if (!initializedRef.current && totalRecords > 0) {
            initializedRef.current = true;
            if (!hideRowsPerPage && !rowOptions.includes(perPageCount)) {
                setPerPageCount(rowOptions[0]);
                setCurrentPage(1);
            }
        }
    }, [totalRecords]);
    if (!((tableData === null || tableData === void 0 ? void 0 : tableData.length) > 0 || (totalNumberOfRecords !== undefined && totalNumberOfRecords > 0))) {
        return null;
    }
    var handleRowsChange = function (value) {
        setPerPageCount(value);
        setCurrentPage(1);
    };
    var startRecord = totalRecords === 0 ? 0 : (currentPage - 1) * perPageCount + 1;
    var endRecord = Math.min(currentPage * perPageCount, totalRecords);
    var arrowButtonSx = {
        width: 32,
        height: 32,
        border: "1px solid ".concat(baseColors.greyPreset[40]),
        borderRadius: '50%',
        color: baseColors.greyPreset[10],
        backgroundColor: baseColors.fullWhite,
        '&.Mui-disabled': {
            color: baseColors.greyPreset[30],
            borderColor: baseColors.greyPreset[40],
        },
    };
    return (React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", width: "100%", px: 0, py: 0.5 },
        !hideRowsPerPage && (React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
            React.createElement(Typography, { variant: "body2", sx: { fontSize: 14, fontWeight: 500, color: baseColors.greyPreset[10], whiteSpace: 'nowrap' } }, "Rows per page:"),
            React.createElement(Select, { value: perPageCount, onChange: function (e) { return handleRowsChange(Number(e.target.value)); }, size: "small", sx: {
                    fontSize: 14,
                    fontWeight: 600,
                    height: 34,
                    minWidth: 70,
                    color: baseColors.greyPreset[10],
                    backgroundColor: baseColors.fullWhite,
                    '.MuiOutlinedInput-notchedOutline': {
                        borderColor: baseColors.greyPreset[40],
                        borderRadius: '8px',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: baseColors.greyPreset[30],
                    },
                    '.MuiSelect-select': {
                        py: 0,
                        px: 1.5,
                    },
                } }, rowOptions.map(function (opt) { return (React.createElement(MenuItem, { key: opt, value: opt, sx: { fontSize: 14 } }, opt)); })))),
        React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2, sx: { ml: hideRowsPerPage ? 'auto' : 0 } },
            React.createElement(Typography, { variant: "body2", sx: { fontSize: 14, fontWeight: 500, color: baseColors.greyPreset[10], whiteSpace: 'nowrap' } },
                startRecord,
                " - ",
                endRecord,
                " of ",
                totalRecords),
            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
                React.createElement(IconButton, { size: "small", onClick: function () { return canGoPrev && setCurrentPage(currentPage - 1); }, disabled: !canGoPrev, sx: arrowButtonSx },
                    React.createElement(ArrowBackIcon, { sx: { fontSize: 16 } })),
                React.createElement(IconButton, { size: "small", onClick: function () { return canGoNext && setCurrentPage(currentPage + 1); }, disabled: !canGoNext, sx: arrowButtonSx },
                    React.createElement(ArrowForwardIcon, { sx: { fontSize: 16 } }))))));
};
export default CommonTablePagination;
